<template>
  <div id="app">
    <div class="mobile_nav pos_fx" v-if="show">
      <Navigation type="mobile" v-if="show" @change="show = false"></Navigation>
    </div>
    <div :class="['header pos_fx',scrollTop > 100 ? 'bgs' : '']">
      <div class="am-container dis_fx">
        <div class="logo"><router-link to="/">
          <img v-if="apiLangType==1" src="./assets/logo.png" class="img"/>
          <img v-else src="./assets/logo_en.png" class="img"/>
        </router-link></div>
        <div :class="['am-show-sm']" class="lang" @click="lang_change()">
            {{ langType ? "EN" : "CN" }}
        </div>
        <div :class="['mobile_menu am-show-sm',show?'open':'']" @click="show = !show">
          <span></span>
          <span></span>
          <span></span>
        </div>
        <div class="nav am-hide-sm">
          <Navigation type="pc"></Navigation>
        </div>
      </div>
    </div>
    <router-view/>
    <!-- <div class="am-container footertitle f_title am-hide-sm">
      <div class="titles titlecontact">
        <img src="./assets/titlecontact.png" class="img f_img"/>
        <span v-show="apiLangType==1">{{ $t('home.contact') }}</span>
      </div>
    </div>
    <div class="footertitle am-show-sm">
      <div class="titles">
        <img src="./assets/wap/titlecontact.png" class="img"/>
      </div>
    </div> -->

    
    <div class="footer" id="contact">
      <div class="am-container dis_fx">
        <div class="logo">
          <img v-show="apiLangType==1" style="width: 180px;" src="./assets/logo_keyi.jpg">
          <img v-show="apiLangType==2" style="width: 180px;" src="./assets/logo_en1.jpg">
        </div>
        <div class="nav">
          <!-- <Navigation type="footer"></Navigation> -->
         <router-link style="padding: 10px 0;" :to="item.to" tag="a" v-for="(item,index) in nav" :key="index" type="pc">{{item.name}}</router-link>
        </div>
        <div class="dis_fx" style="flex-direction: column;flex: 1">
          <div class="contact_ewm dis_fx">
            <div class="contact dis_fx">
              <div class="item">
                <!-- <h2>{{ apiLangType==1?companyInfo.city:companyInfo.cityEn }}</h2>
                <p>{{ apiLangType==1?companyInfo.address:companyInfo.addressEn }}</p> -->
                <p>{{ $t('home.contactPhoneText') }}：{{ $t('home.contactPhoneTel') }}</p>
                <p v-if="apiLangType==2">Mobile / WhatsApp： +86-15116925991</p>
                <p>{{ $t('home.email') }}：sales@ikey-medical.com</p>
                <p><span :style="{width:apiLangType ==1?'44px':'54px'}" style="display: inline-block;" ></span>HR@ikey-mdeical.com</p>
                <p>{{ $t('home.address') }}：{{ $t('home.bjAddress') }}</p>
               <!-- <a href="javascript:void(0);">{{companyInfo.email }}</a> -->
              </div>
<!--              <div class="item">-->
<!--                <h2>{{ $t('home.shanghai') }}</h2>-->
<!--                <p>{{ $t('home.shAddress') }}</p>-->
<!--                <a href="mailto:Beijing@ikey.com">Shanghai@ikey.com</a>-->
<!--              </div>-->
            </div>
            <div class="ewm">
              <img v-show="apiLangType==1" src="./assets/qrcode.jpg" class="img" />
            </div>
          </div>
          <div class="copy">©2026 {{ $t('home.companyName') }} <a href="">{{ $t('home.copyright') }}</a> | <a href="https://beian.miit.gov.cn">京ICP备18062462号-2</a> | (京)网药械信息备字（2024）第 00212 号</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Navigation from "@/components/Navigation";
import {getCompanyList} from "@/api/home";
export default {
  name: 'App',
  components: {
    Navigation
  },
  data(){
    return {
      show: false,
      scrollTop: 0,
      companyInfo:{},
      langType:
        this.cookie.get("lang") == "" ||
        this.cookie.get("lang") == undefined ||
        this.cookie.get("lang") == "zh"
          ? true
          : false,
      nav: [
          { name: this.$t("home.home"), to: "/", id: 0 },
          { name: this.$t("home.about"), to: "/about", id: 1 },
          { name: this.$t("home.contact"), to: "/contact", id: 2 },
          { name: this.$t("home.news"), to: "/new", id: 3 },
          // {
          //   name: this.$t("home.product"),
          //   to: "/productList",
          //   id: 3,
          //   show: false,
          //   // childList: oneList,
          // },
        ]
    }
  },
  watch: {
    $route(){
      this.show = false
    }
  },
  created(){
    // getCompanyList({}).then((res)=>{
    //   this.companyInfo=res.rows.length?res.rows[0]:{};
    // })
  },
  mounted () {
    this.handleScroll()
    window.addEventListener('scroll', this.handleScroll, true) // 监听页面滚动
  },
  methods: {
    handleScroll () {
      let scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop
      this.scrollTop = scrollTop
    },
    lang_change() {
      this.langType = !this.langType;
      if (this.langType) {
        this.$i18n.locale = "zh";
        this.set_cookie("lang", "zh", 6); // 第一个参数是名字，第二个参数是当前的语言，第三个参数是表示 cookie 过期时间，可能是6（天）
      } else {
        this.$i18n.locale = "en";
        this.set_cookie("lang", "en", 6);
      }
      window.location.href = '/'
    },
  },
  beforeDestroy () {
    window.removeEventListener('scroll', this.handleScroll)
  },
}
</script>

<style>
@import "@/common/self-adaption.css";
@import "@/common/common.css";
</style>
<style lang="scss">
.header{
  width: 100%;
  z-index: 99;
  width: 100%;
  left: 0;
  top: 0;
  transition: all 0.3s;
  &.bgs{
    background: rgba(0,0,0,0.3);
    .logo{
      width: 320px;
      a{
        padding: 5px 0;
      }
    }
  }
  .am-container{
    align-items: flex-start;
  }
  .logo{
    width: 380px;
    max-width: 36%;
    margin-right: auto;
    transition: all 0.3s;
    a{
      width: 100%;
      padding: 8% 0;
      display: flex;
      align-items: center;
      justify-content: center;
      background: url("~@/assets/logobg.jpg") no-repeat center top;
      background-size: 100%;
      transition: all 0.3s;
      img{
        max-width: 80%;
      }
    }
  }
  .nav{
    flex: 1;
    margin-left: 12%;
    .item{
      flex: 1;
      text-align: center;
      position: relative;
      >a{
        display: inline-block;
        line-height: 60px;
        color: #fff;
        font-size: 1.8rem;
        text-align: center;
        transition: all 0.3s;
        border-top: 4px solid transparent;
        margin-top: 15px;
        &.router-link-exact-active,
        &:hover{
          color: #443185;
        }
        &.router-link-exact-active{
          border-color: #443185;
        }
      }
    }
    .child{
      position: absolute;
      left: 100%;
      top: 100%;
      width: 100%;
      min-width: 290px;
      background: rgba(53,50,131,.9);
      padding: 1.5rem;
      transform: translate(-50%,0);
      .as,a{
        cursor: pointer;
        color: #fff;
        font-size: 1.4rem;
        line-height: 4rem;
        text-align: left;
        transition: all 0.3s;
        &:hover{
          color: #ea4fb1;
        }
        img{
          transform: rotate(-90deg);
          max-width: 2rem;
          transition: all 0.3s;
          width: 20px;
          height: 20px;
        }
        &.open{
          img{
            transform: rotate(0);
          }
        }
      }
    }
    .child2{
      .as,a{
        cursor: pointer;
        display: block;
        text-align: center;
        transition: all 0.3s;
        font-size: 1.4rem;
        font-weight: 400;
        &:hover{
          color: #ea4fb1;
        }
      }
      img{
          transform: rotate(-90deg);
          max-width: 2rem;
          transition: all 0.3s;
        }
        &.open{
          img{
            transform: rotate(0);
          }
        }
    }
  }
}
.footertitle{
  margin-top: 5%;
}
.f_title{
  .titlecontact{
    position: relative;
    .f_img{
      width: 80%;
    }
    span{
    position: absolute;
    left: 15%;
    font-size: 35px;
    top: 15%;
    color: #fff;
    font-weight: 350;
  }
  }

}
.footer{
  padding: 5% 0;
  background: url("~@/assets/footerbg.jpg") no-repeat center top;
  background-size: 100% 100%;
  .am-container{
    align-items: stretch;
    padding: 0 5%
  }
  .nav{
    padding: 0 6%;
    >.dis_fx{
      height: 100%;
      flex-direction: column;
    }
    a{
      padding: 0 20px;
      display: block;
      color: #4a515d;
      font-size: 1.4rem;
      font-weight: 600;
      transition: all 0.3s;
      >img{
        display: none;
      }
      &:hover{
        color: #443185;
      }
    }
  }
  .copy{
    width: 100%;
    color: #4a515d;
    font-size: 1.4rem;
    line-height: 1.6em;
    a{
      color: #4a515d;
      transition: all 0.3s;
      &:hover{
        color: #443185;
      }
    }
  }
  .contact{
    width: 100%;
    margin-bottom: 10%;
    justify-content: flex-start;
    .item{
      margin-right: 15%;
    }
    h2{
      color: #4a515d;
      font-size: 1.4rem;
      font-weight: 600;
      margin-bottom: 10px;
    }
    p{
      color: #4a515d;
      font-size: 1.45rem;
      line-height: 1.8em;
    }
    a{
      color: #4a515d;
      font-size: 1.4rem;
      font-weight: 400;
      transition: all 0.3s;
      &:hover{
        color: #443185;
      }
    }
  }
  .contact_ewm{
    width: 100%;
    align-items: flex-start;
    .ewm{
        width: 170px;
      }
  }
  
}

.banner{
  justify-content: center;
  img{
    width: 100%;
    min-width: 400px;
  }
}


.slogan{
  margin: 2% auto 0;
  .dis_fx{
    justify-content: center;
    flex-wrap: wrap;
    align-items: stretch;
  }
  .item{
    flex: 1;
    text-align: center;
    h2{
      color: #4a515d;
      font-size: 2.5rem;
      font-weight: 600;
      letter-spacing: 4px;
      line-height: 1em;
    }
    span{
      display: block;
      content: "";
      width: 90px;
      height: 6px;
      background: #d2d6d7;
      margin: 15px auto 8%;
      border-radius: 12px;
    }
    ul{
      display: flex;
      justify-content: space-evenly;
      align-items: center;
      width: 40%;
      min-width: 240px;
      max-width: 100%;
      margin: 0 auto;
      li{
        width: 5px;
        height: 5px;
        border-radius: 50%;
        background: #4a515d;
      }
    }
  }
  .line{
    width: 8px;
    border-radius: 20px;
    background: #4a515d;
  }
  &.subtitle{
    .item{
      width: 700px;
      max-width: 80%;
      flex: none;
    }
  }
}
.lang {
    position: relative;
    left: -20px;
    z-index: 10;
    top: 0;
    font-size: 14px;
    color: #fff;
  }
.mobile_menu{
  width: 2.8rem;
  height: 2rem;
  position: relative;
  span{
    width: 100%;
    height: 2px;
    background: #fff;
    transition: all 0.3s;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%,-50%);
    &:nth-child(1){
      margin-top: -0.8rem;
    }
    &:nth-child(3){
      margin-top: 0.8rem;
    }
  }
  &.open{
    span:nth-child(1){
      transform: translate(-50%,-50%) rotate(45deg);
      margin: 0;
    }
    span:nth-child(2){
      opacity: 0;
    }
    span:nth-child(3){
      transform: translate(-50%,-50%) rotate(-45deg);
      margin: 0;
    }
  }
}
.mobile_nav{
  >.dis_fx{
    display: block;
  }
  z-index: 99;
  left: 0;
  top: 0;
  width: 100%;
  background: rgba(68,49,133,0.9);
  padding: 15% 3rem;
  max-height: 100vh;
  overflow-y: scroll;
  .item{
    a,>.as{
      width: 100%;
      color: #fff;
      cursor: pointer;
      line-height: 4rem;
      padding: 1.5rem 0;
      font-size: 1.4rem;
      border-bottom: 1px solid rgba(255,255,255,0.4);
      img{
        width: 1.6rem;
      }
    }
    .child{
      padding: 1rem 0;
      border-bottom: 1px solid rgba(255,255,255,0.4);
      a,.as{
        color: #fff;
        font-size: 1.4rem;
        line-height: 1.8em;
        padding: 1rem 0;
        cursor: pointer;
        img{
          width: 1.6rem;
          transform: rotate(-90deg);
        }
        &.open{
          img{
            transform: rotate(0);
          }
        }
      }
    }
    .child2{
      padding: 0 2rem;
    }
  }
}
@media screen and (min-width: 769px){
  .mobile_nav,.mobile_menu{
    display: none !important;
  }
}
@media (max-width: 1366px) {
  .header{
    .logo{
      width: 300px;
      a{
        padding: 12% 0;
      }
    }
    .nav{
      .item{
        > a{
          font-size: 1.8rem;
        }
      }
    }
  }
  .slogan{
    .item{
      h2{
        font-size: 3.4rem;
      }
      ul{
        min-width: 180px;
      }
    }
  }
}
@media (max-width: 1024px) {
  .header{
    .logo{
      width: 240px;
      a{
        padding: 6% 0;
      }
    }
    .nav{
      margin-left: 4%;
      .item{
        > a{
          font-size: 1.6rem;
        }
        .child{
          .as{
            font-size: 1.4rem;
          }
        }
      }
    }
  }
  .footer{
    .nav {
      padding: 0 4%;
      a{
        font-size: 1.6rem;
      }
    }
    .contact {
      h2{
        font-size: 1.6rem;
      }
      p,a{
        font-size: 1.4rem;
      }
    }
    .copy{
      font-size: 1.4rem;
    }
  }
}
@media (max-width: 768px) {
  #app{
    overflow: hidden;
  }
  .header{
    &.bgs {
      background: rgba(68,49,133,0.9);
    }
    .am-container{
      padding: 0 2rem;
      align-items: center;
    }
    .logo{
      a{
        padding: 6% 0;
        background: url("~@/assets/wap/logobg.jpg") no-repeat center bottom;
        background-size: 100% 100%;
        img{
          max-width: 70%;
        }
      }
    }
  }
  .footer{
    padding-top: 2rem;
    padding-bottom: 12rem;
    >.dis_fx{
      flex-wrap: wrap;
    }
    .nav{
      width: 100%;
      padding: 0 3%;
      .item{
        width: 100%;
      }
      a,.as{
        width: 100%;
        display: block;
        font-size: 1.4rem;
        line-height: 3.5em;
        border-bottom: 1px solid #bcbcbc;
        padding: 0;
        display: flex;
        align-items: center;
        justify-content: space-between;
        >img{
          display: block;
          width: 1.2rem;
        }
      }
      .child{
        .as{
          border-bottom: none;
          line-height: 3em;
        }
      }
    }
    .contact_ewm{
      padding: 5% 3%;
      align-items: center;
    }
    .ewm{
      max-width: 30%;
    }
    .copy{
      font-size: 1.2rem;
    }
    .contact{
      display: block;
      margin: 0;
      .item{
        padding: 8% 2%;
        margin: 0;
      }
      h2{
        font-size: 1.6rem;
        margin-bottom: 4px;
      }
      p,a{
        font-size: 1.2rem;
      }
    }
    .logo{
      position: absolute;
      bottom: 4rem;
      left: 0;
      text-align: center;
      width: 100%;
      img{
        max-width: 16rem;
      }
    }
  }
  .slogan{
    margin: 6% auto;
    >.dis_fx{
      align-items: center;
      padding: 0;
    }
    .line{
      width: 3px;
      height: 3rem;
    }
    .item{
      h2{
        font-size: 1.4rem;
      }
      span{
        width: 3rem;
        height: 2px;
        margin: 8px auto 15px;
      }
      ul{
        width: 65%;
        min-width: auto;
        li{
          width: 3px;
          height: 3px;
        }
      }
    }
    &.subtitle{
      .item{
        h2{
          font-size: 2rem;
        }
        span{
          width: 4rem;
          height: 3px;
          margin: 8px auto 15px;
        }
        ul{
          width: 40%;
          min-width: auto;
          li{
            width: 3px;
            height: 3px;
          }
        }
      }
    }
  }
}
  .el-menu--popup{
    padding: 0!important;
  }
</style>
